// src/features/scope_module/components/LeftPanel.js
import React from 'react';
import { Layers, Play } from 'lucide-react';
import { useScope } from '../../../contexts/DemoScopeContext';
import PlaybackControls from './PlaybackControls';

const LeftPanel = () => {
  const { layersConfig, updateLayer, analysisEnabled } = useScope();

  // Define standard layer order
  const layerOrder = ['base', 'minutiae', 'heatmap', 'tracking', 'clarity', 'quality', 'playback'];
  const sortedLayerIds = layerOrder.filter(id => layersConfig && layersConfig[id]);

  const handleLayerChange = (id, property, value) => {
    updateLayer(id, property, value);
  };

  return (
    <div className="left-panel">
      <div className="panel-header">
        <Layers size={18} />
        <h3>Layers</h3>
      </div>
      <div className="layers-list">
        {sortedLayerIds.map(layerId => {
          const config = layersConfig[layerId];
          const visible = !!config.visible;
          const disabled = !!config.disabled;
          const opacity = Number.isFinite(config.opacity) ? config.opacity : 1;
          const name = config.name || layerId;

          return (
            <div key={layerId} className={`layer-item ${disabled ? 'disabled' : ''}`}>
              <div className="layer-visibility-control">
                <input
                  type="checkbox"
                  id={`visibility-${layerId}`}
                  checked={visible}
                  onChange={(e) => handleLayerChange(layerId, 'visible', e.target.checked)}
                  disabled={disabled}
                />
                <label htmlFor={`visibility-${layerId}`}>{name}</label>
              </div>

              {layerId !== 'playback' && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                    <input
                        type="range"
                        className="layer-opacity-slider"
                        min="0"
                        max="100"
                        value={Math.round(opacity * 100)}
                        onChange={(e) => handleLayerChange(layerId, 'opacity', parseInt(e.target.value, 10) / 100)}
                        disabled={disabled || !visible}
                    />
                     <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', minWidth: '32px', textAlign: 'right', fontFamily: 'monospace' }}>
                        {Math.round(opacity * 100)}%
                     </span>
                  </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Playback Controls Section */}
      <div className="panel-header" style={{ marginTop: '1rem' }}>
        <Play size={18} />
        <h3>Playback</h3>
      </div>
      <div className="playback-controls-container">
        <PlaybackControls disabled={!analysisEnabled} />
        {!analysisEnabled && (
          <div className="playback-disabled-hint">
            Complete session and run Analyze to enable playback
          </div>
        )}
      </div>
    </div>
  );
};

export default LeftPanel;